window.initFolderDetection = (elementId, dotNetHelper) => {
    const input = document.getElementById(elementId);
    if (!input) return;

    if (input.dataset.folderDetectionInitialized === 'true') return;
    input.dataset.folderDetectionInitialized = 'true';

    let hadChange = false;

    const resetState = () => {
        hadChange = false;
    };

    const startSelection = () => {
        resetState();
    };

    input.addEventListener('click', startSelection);

    const labels = document.querySelectorAll(`label[for="${elementId}"]`);
    labels.forEach(label => {
        label.addEventListener('click', startSelection);
    });

    input.addEventListener('change', () => {
        hadChange = true;

        const files = input.files ? input.files.length : 0;
        if (files === 0) {
            dotNetHelper.invokeMethodAsync('HandleEmptySelection');
        }
    });

    input.addEventListener('cancel', () => {
        if (!hadChange) {
            dotNetHelper.invokeMethodAsync('HandleEmptySelection');
        }
    });

    window.addEventListener('focus', () => {
        setTimeout(() => {
            if (hadChange) return;

            const files = input.files ? input.files.length : 0;
            if (files === 0) return;
        }, 0);
    });
};